export default [
  {
    path: '/advancedProblem/answer',
    name: '高级问题作业',
    component: () => import(/* webpackChunkName: "advancedProblem" */ '../views/advancedProblem/index.vue')
  }
];
